/**
 * Pure date arithmetic utilities.
 * No Intl/locale dependency — just date math on YYYY-MM-DD strings and Date objects.
 */

/** Parse 'YYYY-MM-DD' into local-midnight Date to avoid UTC timezone offset issues. */
export function parseLocalDate(dateStr: string): Date {
  const y = parseInt(dateStr.substring(0, 4), 10);
  const m = parseInt(dateStr.substring(5, 7), 10) - 1;
  const d = parseInt(dateStr.substring(8, 10), 10);
  return new Date(y, m, d);
}

/** Format a Date as 'YYYY-MM-DD' using local timezone. */
export function toDateString(d: Date): string {
  return d.toISOString().slice(0, 10);
}

/** Return a new Date that is `n` days after `d`. */
export function addDays(d: Date, n: number): Date {
  const result = new Date(d);
  result.setDate(result.getDate() + n);
  return result;
}

/** Return `d + n` days as a 'YYYY-MM-DD' string. */
export function addDaysToString(d: Date, n: number): string {
  const result = new Date(d);
  result.setDate(result.getDate() + n);
  return result.toISOString().slice(0, 10);
}

/** Signed days between two date strings (b - a). Uses Math.round. */
export function daysBetween(a: string, b: string): number {
  const da = new Date(a + 'T00:00:00');
  const db = new Date(b + 'T00:00:00');
  return Math.round((db.getTime() - da.getTime()) / 86400000);
}

/** Absolute days between two Date objects. Uses Math.abs + Math.floor. */
export function daysBetweenDates(a: Date, b: Date): number {
  return Math.abs(Math.floor((a.getTime() - b.getTime()) / (1000 * 60 * 60 * 24)));
}

/** Inclusive duration in days between two YYYY-MM-DD strings (end - start + 1). */
export function durationDaysInclusive(start: string, end: string): number {
  const s = new Date(start + 'T00:00:00');
  const e = new Date(end + 'T00:00:00');
  return Math.round((e.getTime() - s.getTime()) / 86400000) + 1;
}
